import type { Builder } from "../../types.js";
import { buildHierarchyEndpoints } from "./hierarchyEndpoints.js";

export const buildProjectEndpoints = (builder: Builder) => ({
	...buildHierarchyEndpoints(builder),
});
